import React, { useEffect, useRef } from "react"

const TranspondForm = ({
  title,
  formId,
  srcUrl,
  className = "transpond-form",
}) => {
  const formRef = useRef()
  useEffect(() => {
    if (!formRef.current?.querySelector("script")) {
      const script = document.createElement("script")
      script.src = srcUrl
      script.async = true
      script.id = formId
      formRef.current.appendChild(script)
    }
  }, [formRef.current])
  return (
    <div className={className} ref={formRef}>
      {title && <h2 className="h4">{title}</h2>}
    </div>
  )
}

export default TranspondForm
